
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"V1_00000060709404851460198690000016216143044135808910_"}},[_c('path',{staticClass:"st0",attrs:{"d":"M36.3 43.3c-3.2 0-6.4-1.2-8.9-3.7l-3.1-3.1c-1-1-1-2.6 0-3.6s2.6-1 3.6 0L31 36c2.9 2.9 7.7 2.9 10.6 0l14.8-14.8c1.4-1.4 2.2-3.3 2.2-5.3s-.8-3.9-2.2-5.3l-3.1-3.1c-2.9-2.9-7.7-2.9-10.6 0l-9.6 9.6c-1 1-2.6 1-3.6 0s-1-2.6 0-3.6L39.2 4C44.1-.9 52.1-.9 57 4l3 3c2.4 2.4 3.7 5.5 3.7 8.9 0 3.4-1.3 6.5-3.7 8.9L45.2 39.7c-2.5 2.4-5.7 3.6-8.9 3.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M15.9 63.7c-3.2 0-6.4-1.2-8.9-3.7l-3-3C1.6 54.6.3 51.5.3 48.1c0-3.4 1.3-6.5 3.7-8.9l14.8-14.8c4.9-4.9 12.9-4.9 17.8 0l3.1 3.1c1 1 1 2.6 0 3.6s-2.6 1-3.6 0L33 27.9c-2.9-2.9-7.7-2.9-10.6 0L7.6 42.8c-1.4 1.4-2.2 3.3-2.2 5.3s.8 3.9 2.2 5.3l3.1 3.1c2.9 2.9 7.7 2.9 10.6 0l9.8-9.8c1-1 2.6-1 3.6 0s1 2.6 0 3.6L24.8 60c-2.4 2.5-5.7 3.7-8.9 3.7z"}})])])
          )
        }
      }
    